import {produce} from "immer";

export const actions = {
  SHOW_MODAL: "SHOW_MODAL",
  HIDE_MODAL: "HIDE_MODAL",
};

const initialState = {
  items: [],
};

export default produce((draft, action) => {
  const {type, modalProps, modalType, id} = action;
  if (!draft) {
    return initialState;
  }

  switch (type) {
    case actions.SHOW_MODAL: {
      draft.items.push({
        modalProps,
        modalType,
        id,
      });
      break;
    }
    case actions.HIDE_MODAL: {
      draft.items = draft.items.filter((modal) => modal.id !== id);
      break;
    }
    default:
      break;
  }
});
